// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import * as Plugin_0 from '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/src/runtime.ts';
import * as Plugin_1 from '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/src/.kmi-production/plugin-monitor/runtime.tsx';
import { PluginManager } from '@kmi/kmijs';

function __defaultExport (obj) {
  const { default: defineFunc, ...overrides } = obj;
  const definedExports = (typeof defineFunc === 'function' ? defineFunc() : defineFunc) || {};
  if (process.env.NODE_ENV !== 'production') {
    const defineAppKeys = Object.keys(definedExports);
    // should use named exports keys
    const shouldNamedExportKeys = [];
    const intersectionKeys = defineAppKeys.filter(key => shouldNamedExportKeys.includes(key));
    if (intersectionKeys.length) {
      const errorMsg = `[Kmi]: The export \`${intersectionKeys.join(', ')}\` is not supported in \`defineApp()\` (app.tsx) .\n
         You should use the named export:\n
         export const ${intersectionKeys[0]} = ...
`;
      console.error(errorMsg);
    }
    // ensure export only once
    const overrideKeys = Object.keys(overrides || {});
    const multiExportKeys = defineAppKeys.filter(key => overrideKeys.includes(key));
    if (multiExportKeys.length) {
      const errorMsg = `[Kmi]: The export \`${multiExportKeys.join(', ')}\` is with multiple exports in \`defineApp()\` and named export (app.tsx): .\n
         You should export only once:\n
         export const ${multiExportKeys[0]} = ...  or  export default defineApp({ ${multiExportKeys[0]} })
`;
      terminal.error(errorMsg);
      console.error(errorMsg);
    }
  }
  return {
    ...definedExports,
    ...overrides
  };
}
export function getPlugins() {
  return [
    {
      apply: Plugin_0,
      path: process.env.NODE_ENV === 'production' ? void 0 : '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/src/runtime.ts',
    },
    {
      apply: Plugin_1,
      path: process.env.NODE_ENV === 'production' ? void 0 : '/media/disk1/fordata/jenkins/rbdNodeJs/workspace/src/.kmi-production/plugin-monitor/runtime.tsx',
    },
  ];
}

export function getValidKeys() {
  return ['innerProvider','i18nProvider','accessProvider','dataflowProvider','outerProvider','rootContainer','onPluginCreated','monitorConfig','monitorErrorConfig','qiankun','onRequestCreated',];
}

let pluginManager = null;

// 确保 webpack 模式 import.meta.hot 代码被 tree shaking 掉
const isDev = process.env.NODE_ENV === 'development';

export function createPluginManager() {
  pluginManager = PluginManager.create({
    plugins: getPlugins(),
    validKeys: getValidKeys(),
  });

  // fix https://github.com/umijs/umi/issues/10047
  // https://vitejs.dev/guide/api-hmr.html#hot-data 通过 hot data 持久化 pluginManager 解决 vite 热更时 getPluginManager 获取到 null 的情况
  if (isDev && import.meta.hot) {
    import.meta.hot.data.pluginManager = pluginManager
  }
  return pluginManager;
}

export function getPluginManager() {
  // vite 热更模式优先从 hot data 中获取 pluginManager
  if (isDev && import.meta.hot) {
    return import.meta.hot.data.pluginManager || pluginManager
  }
  return pluginManager;
}